import classNames from "classnames";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";
import React from "react";

class MediaShare extends React.Component {
  render() {
    let bgStyle = {};

    if (this.props.image) {
      bgStyle = {
        backgroundImage: "url(" + this.props.image + ")"
      };
    }

    let title = this.props.title,
      description = this.props.description;

    if (title.length > 50) {
      title = title.slice(0, 50) + "...";
    }
    if (description.length > 150) {
      description = description.slice(0, 150) + "...";
    }

    const descriptionClass = classNames("desc", {
      "hidden-qr": !this.props.displayQr || !this.props.link
    });

    return (
      <div className="share-card">
        <div className="thumbnail" style={bgStyle} />
        <div className={descriptionClass}>
          <h1 className="event-name">{title}</h1>
          <h2 className="event-desc">{description}</h2>

          {typeof this.props.link !== "undefined" && this.props.displayQr && (
            <QRCode value={this.props.link} level="L" />
          )}
        </div>
      </div>
    );
  }
}

MediaShare.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  displayQr: PropTypes.bool,
  link: PropTypes.string
};

MediaShare.defaultProps = {
  title: "",
  description: "",
  image: ""
};

export default MediaShare;
